import { render, staticRenderFns } from "./InsuredInfoItem.vue?vue&type=template&id=a933dcd0&"
import script from "./InsuredInfoItem.vue?vue&type=script&lang=js&"
export * from "./InsuredInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports